import { Avatar } from '@components/block/Avatar/Avatar';
import { Logo } from '@components/block/Header/Logo';

export function UploadedDocumentHeader() {
  return (
    <div className="flex gap-5 items-center bg-primary-root h-[70px]">
      <div className="flex-[0.35]" />
      <div className="flex-[1.68] pl-10">
        <Logo clickable={false} />
      </div>
      <div className="flex-[5]" />
      <div className="flex-1 hidden md:flex justify-end pr-1">
        <Avatar className="h-[70px]" alt="Dieter" />
      </div>
      <div className="flex-[0.9]" />
    </div>
  );
}
